import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexFill,
  ApexTooltip,
  ApexXAxis,
  ApexLegend,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexPlotOptions,
  ApexYAxis,
  ApexGrid,
} from 'ng-apexcharts';
import { Subscription } from 'rxjs';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  markers: any;
  stroke: any;
  yaxis: ApexYAxis | ApexYAxis[];
  plotOptions: ApexPlotOptions;
  dataLabels: ApexDataLabels;
  colors: string[];
  labels: string[] | number[];
  title: ApexTitleSubtitle;
  subtitle: ApexTitleSubtitle;
  legend: ApexLegend;
  fill: ApexFill;
  tooltip: ApexTooltip;
  grid?: ApexGrid;
};

declare global {
  interface Window {
    Apex: any;
  }
}

@Component({
  selector: 'app-device-status-over-time-chart',
  templateUrl: './device-status-over-time-chart.component.html',
  styleUrls: ['./device-status-over-time-chart.component.scss'],
})
export class DeviceStatusOverTimeChartComponent implements OnInit, OnDestroy {
  @Input() data: any;
  @ViewChild('chart') chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;
  public commonAreaSparlineOptions: Partial<ChartOptions> = {};

  graphLoaded = false;
  sidenavObservable: Subscription;

  constructor(private tools: ToolsService, private navigationService: NavigationService) {}

  ngOnInit() {
    const colors =
      this.data != null && this.data.status.length > 0
        ? this.data.status.map((status) => {
            if (status == 1) {
              return '#4BB543';
            }
            return '#D15C6E';
          })
        : ['#D15C6E'];

    this.chartOptions = {
      series: [
        {
          name: 'Online',
          data: this.data != null && this.data.status != null ? this.data.status.map((status) => status) : [],
        },
      ],
      colors: colors,
      title: {
        // sv-SE because yyyy/MM/dd
        text: 'Status over time (' + this.tools.GetStartOfMonth(new Date()).toLocaleDateString('sv-SE') + ' - ' + new Date().toLocaleDateString('sv-SE') + ')',
        align: 'left',
        style: {
          fontSize: '24px',
          color: '#08074B',
          fontWeight: '400',
        },
      },
      dataLabels: {
        enabled: true,
        textAnchor: 'middle',
        formatter: function (val) {
          const lable = val == 1 ? '1' : '0';
          return lable;
        },
        offsetX: 1,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: 'bottom',
          },
        },
      },
      chart: {
        id: 'chart3',
        type: 'line',
        height: 300,
        dropShadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2,
        },
      },
      markers: {
        size: 0,
      },
      stroke: {
        curve: 'smooth',
        width: 4,
      },
      grid: {
        yaxis: {
          lines: {
            show: false,
          },
        },
        xaxis: {
          lines: {
            show: true,
          },
        },
      },
      yaxis: {
        min: 0,
        max: 1,
        tickAmount: 1,
        decimalsInFloat: 0,
      },
      xaxis: {
        type: 'datetime',
        categories: this.data != null ? this.data.weeks.map((week) => week) : [],
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: true,
        },
        labels: {
          format: 'dd MMM',
        },
      },
      tooltip: {
        fixed: {
          enabled: false,
        },
        x: {
          show: false,
        },
        marker: {
          show: false,
        },
      },
    };

    this.graphLoaded = true;

    this.sidenavObservable = this.navigationService.GetSideNav(() => {
      if (this.graphLoaded != false) {
        const temp = this.graphLoaded;
        this.graphLoaded = false;
        setTimeout(() => {
          this.graphLoaded = temp;
        });
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sidenavObservable != null) {
      this.sidenavObservable.unsubscribe();
    }
  }
}
